export const BASE_URL = (url) =>{
  // let URL = `http://172.20.10.6:8080/monportail-internet-api/${url}`;
  // let URL = `http://192.168.1.191:8080/monportail-internet-api/${url}`;
  // let URL = `http://moninternet.mtn.ci/monportail-internet-api/${url}`; // (url pour api en ligne ancien)
  let URL = `http://moninternet.mtn.ci/monportail-internet-api/${url}`; // (url pour api en ligne nouveau)
  // let URL = `http://10.20.0.12:8080/monportail-internet-api/${url}`;
 return URL
};
